import { Applications } from './Applications';
export class PlatformPrivateServices {
    constructor(hostAPI, ds, experimentsAPI, events, editorPointerAPI) {
        this.hostAPI = hostAPI;
        this.ds = ds;
        this.experimentsAPI = experimentsAPI;
        this.events = events;
        this.editorPointerAPI = editorPointerAPI;
        this.apps = new Applications(this.events);
    }
}
//# sourceMappingURL=PlatformPrivateServices.js.map